export enum PaymentSolutionEnum {
  GOOGLE_PAY = '502',
  APPLE_PAY = '504'
}
